import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  bannerRoot: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    gap: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(7),
    backgroundColor: theme.palette.dpoDayNavy,
    boxShadow: theme.shadows[4],
    zIndex: 1999,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: 80,
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      padding: theme.spacing(2, 3),
    },
  },
  bannerHexagon: {
    display: 'block',
    height: '100%',
    width: 'auto',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      height: 56,
    },
  },
  bannerInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    flex: '0 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      textAlign: 'center',
      overflow: 'visible',
    },
  },
  bannerInfoTitleWrapper: {
    display: 'block',
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      overflow: 'visible',
    },
  },
  bannerInfoTitle: {
    display: 'inline-block',
    color: theme.palette.common.white,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 15,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      whiteSpace: 'normal',
    },
  },
  bannerInfoRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    minWidth: 0,
    columnGap: theme.spacing(1.5),
    rowGap: theme.spacing(0.25),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: 'auto',
      columnGap: theme.spacing(0.5),
      rowGap: theme.spacing(0.5),
    },
  },
  bannerLocation: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.spacing(0.75),
  },
  cuboLogo: {
    display: 'block',
    height: 20,
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: 24,
    },
  },
  bannerLocationText: {
    color: theme.palette.common.white,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 12,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  textBold: {
    fontWeight: 800,
    textTransform: 'uppercase',
  },
  discountPill: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  countdownText: {
    fontSize: 15,
    lineHeight: 1.1,
  },
  ctaButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    borderRadius: 24,
    padding: theme.spacing(1, 2.5),
    boxSizing: 'border-box',
    flexShrink: 0,
    backgroundColor: theme.palette.dpoDayButtonNavy,
    border: `1.5px solid rgba(255, 255, 255, 0.45)`,
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'opacity 0.15s ease',
    '&:hover': {
      opacity: 0.85,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.common.white}`,
      outlineOffset: 2,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.75, 2),
    },
  },
  ctaButtonText: {
    color: theme.palette.common.white,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1.25,
    textAlign: 'center',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    letterSpacing: 0.3,
  },
  ctaIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: theme.palette.greenPantone,
    flexShrink: 0,
  },
  ctaIcon: {
    color: theme.palette.common.white,
    fontSize: 14,
  },
  bannerClose: {
    position: 'absolute',
    top: '50%',
    right: theme.spacing(1),
    transform: 'translateY(-50%)',
    padding: theme.spacing(0.75),
    color: theme.palette.common.white,
    opacity: 0.8,
    '&:hover': {
      opacity: 1,
      backgroundColor: theme.palette.common.black,
    },
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(1),
      transform: 'none',
      width: 40,
      height: 40,
      padding: theme.spacing(1),
    },
  },
}))

export default styles
